(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-footer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cookie-preferences]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        event.preventDefault();
        window.privacyBanner.showPreferences();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{document.querySelectorAll('.noveo-desktop-mega-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open')})});
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('.noveo-desktop-mega-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary')?.focus()})});
  } catch(e) { console.error(e); }
})();

})();
